module.exports = __webpack_public_path__ + "static/img/cjfw-companyQualification.d33c414e.png";